// how an account is used, independent of what it may do (that is `scopes`).
// purely descriptive downstream -- the gateway does not gate access on it
export const ACCOUNT_CLASSIFICATIONS = [
    "user",
    "tester",
    "service",
] as const;

export type AccountClassification = typeof ACCOUNT_CLASSIFICATIONS[number];

export const DEFAULT_ACCOUNT_CLASSIFICATION: AccountClassification = "user";

export const isAccountClassification = (
    value: string | null | undefined,
): value is AccountClassification => {
    return !!value &&
        (ACCOUNT_CLASSIFICATIONS as readonly string[]).includes(value);
};

export type AuthIdentity = {
    userId: string;
    username: string;
    scopes: string[];
    allowedServices: string[];
    identityType: "session" | "token";
    tokenExpiresAt: string | null;
    disabled: boolean;
    createdAt: string;
    lastLoginAt: string | null;
    classification: AccountClassification;
};

export const Scope = {
    Admin: "admin",
    Readonly: "readonly",
} as const;

export const AUTH_HEADERS = {
    userId: "x-auth-user-id",
    username: "x-auth-username",
    identityType: "x-auth-identity-type",
    scopes: "x-auth-scopes",
    allowedServices: "x-auth-allowed-services",
    tokenExpiresAt: "x-auth-token-expires-at",
    disabled: "x-auth-identity-disabled",
    createdAt: "x-auth-identity-created-at",
    lastLoginAt: "x-auth-identity-last-login-at",
    classification: "x-auth-classification",
} as const;

export type AuthEnv = {
    Variables: {
        identity: AuthIdentity;
    };
};
